import type { ParsedCreativeHashData } from "./parse-creative-hash-data";

/** Text fields are `null` when the creative has no data for them, so the drawer can omit them. */
export interface DrawerNarrativeContent {
  topics: string | null;
  presenterAge: string | null;
  targetAudience: string | null;
  angle: string | null;
  painPoint: string | null;
  motivation: string | null;
  persona: string | null;
  concepts: string[];
  sequence: ParsedCreativeHashData["sequence"];
  verbalHooks: string | null;
  textOverlay: string | null;
}

function nonBlank(values: string[]): string[] {
  return values.filter((value) => value.trim() !== "");
}

function joinOrNull(values: string[]): string | null {
  const present = nonBlank(values);
  return present.length > 0 ? present.join(", ") : null;
}

export function mapDrawerNarrativeContent(parsed: ParsedCreativeHashData | null): DrawerNarrativeContent {
  if (!parsed) {
    return {
      topics: null,
      presenterAge: null,
      targetAudience: null,
      angle: null,
      painPoint: null,
      motivation: null,
      persona: null,
      concepts: [],
      sequence: [],
      verbalHooks: null,
      textOverlay: null,
    };
  }

  return {
    topics: joinOrNull(parsed.topics),
    presenterAge: joinOrNull(parsed.Age),
    targetAudience: joinOrNull(parsed.target_audience),
    angle: joinOrNull(parsed.angle),
    painPoint: joinOrNull(parsed.painPoint),
    motivation: joinOrNull(parsed.motivation),
    persona: joinOrNull(parsed.personalities),
    concepts: nonBlank(parsed.concepts),
    sequence: parsed.sequence,
    verbalHooks: parsed.verbalHooks,
    textOverlay: parsed.textOverlay,
  };
}
